<template>
    <div id="self-publishing-flow-files">
        <div id="form-content" class="row align-items-center">
            <transition mode="out-in" name="fade">
                <div v-if="status === 'done'" key="files-uploaded" class="col-12">
                    <div class="row align-items-center">
                        <div class="col-2">
                            <img :src="addToCartSVG" alt="Add to cart"/>
                        </div>
                        <div class="col-10 align-items-center text-left">
                            <h3 v-html="$t('UploadProductFiles.orderYourProductToStartChecks')"/>
                        </div>
                    </div>
                </div>
                <div v-else-if="product._id && status === 'pending' || status === 'errored'" id="file-inputs" key="file-inputs" class="col-12">
                    <form @submit.prevent="sendProductFiles">
                        <div class="row align-items-center">
                            <div class="col-4">
                                <ProductFileStatusBadge class="w-100" book-part="corpus" :product="product"/>
                            </div>
                            <div class="col-8">
                                <div class="custom-file">
                                    <input ref="CorpusFileInput" @change="checkFileInput('corpus')"
                                           class="custom-file-input" :disabled="!product.canUploadCorpusFile"
                                           type="file" accept="application/pdf" id="book-corpus-file"
                                           v-tooltip="corpusFileInputTooltip"/>
                                    <label class="custom-file-label" :class="{ 'custom-file-label-success': !!corpus.file }" for="book-corpus-file"
                                           v-html="this.corpusFileInputLabel"/>
                                </div>
                                <div v-if="product.files.corpus.status === 'uploaded'"
                                     class="badge badge-warning mt-2">
                                    <i class="fa fa-exclamation-triangle mr-2"/>
                                    <span v-html="$t('UploadProductFiles.fileWillBeReplaced')"/>
                                </div>
                                <div v-else-if="product.files.corpus.status === 'to-upload' || product.files.corpus.status === 'errored'"
                                    class="mt-2 badge badge-info w-100">
                                    <div class="row align-items-center text-left">
                                        <i class="fa fa-expand-alt fa-2x text-center col-1 pr-0"/>
                                        <span class="col-11" v-html="$t('UploadProductFiles.yourCorpusFileMustBeDimensions', product.dimensions)"/>
                                    </div>
                                    <div class="row align-items-center mt-3 text-left">
                                        <i class="fa fa-book-open fa-2x text-center col-1 pr-0"/>
                                        <span class="col-11" v-html="$t('UploadProductFiles.yourCorpusFileMustContainPages', { count: product.paging.total })"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="my-3"/>
                        <div class="row align-items-center">
                            <div class="col-4">
                                <ProductFileStatusBadge class="w-100" book-part="cover" :product="product"/>
                            </div>
                            <div class="col-8">
                                <div class="custom-file">
                                    <input ref="CoverFileInput" @change="checkFileInput('cover')"
                                           class="custom-file-input" :disabled="!product.canUploadCoverFile"
                                           type="file" accept="application/pdf" id="book-cover-file"
                                           v-tooltip="coverFileInputTooltip"/>
                                    <label class="custom-file-label" :class="{ 'custom-file-label-success': !!cover.file }" for="book-cover-file"
                                           v-html="this.coverFileInputLabel"/>
                                </div>
                                <div v-if="product.files.cover.status === 'uploaded'"
                                     class="badge badge-warning mt-2">
                                    <i class="fa fa-exclamation-triangle mr-2"/>
                                    <span v-html="$t('UploadProductFiles.fileWillBeReplaced')"/>
                                </div>
                                <div v-else-if="product.files.cover.status === 'to-upload' || product.files.cover.status === 'errored'"
                                     class="mt-2 badge badge-info w-100">
                                    <div class="row align-items-center text-left">
                                        <i class="fa fa-expand-alt fa-2x text-center col-1 pr-0"/>
                                        <div class="col-11">
                                            <div v-html="$t('UploadProductFiles.yourCoverFileMustBeDimensions', product.openBookDimensions)"/>
                                        </div>
                                    </div>
                                    <div class="row align-items-center mt-3 text-left">
                                        <i class="fa fa-book-open fa-2x text-center col-1 pr-0"/>
                                        <span class="col-11" v-html="$t('UploadProductFiles.yourCoverMustBePlank')"/>
                                    </div>
                                </div>
                            </div>
                            <div class="offset-4 col-8 d-flex justify-content-center mt-2">
                                <img :src="IMGs.bookDimensions" width="300" alt="Book dimensions"/>
                            </div>
                        </div>
                        <div v-if="APIClient === 'imprimer-vos-livres'">
                            <div class="row align-items-center">
                                <div class="col-9 font-italic" v-html="$t('UploadProductFiles.ifYouReNotSureAboutYourFiles')"/>
                                <div class="col-3">
                                    <a class="btn btn-outline-primary btn-lg btn-block" href="/pdf/imprimer-vos-livres/product-creation-guide.pdf"
                                       download="Guide PAO.pdf">
                                        <i class="fa fa-file-pdf fa-2x mr-2"/>
                                        <span v-html="$t('UploadProductFiles.productCreationGuide')"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div v-if="APIClient === 'imprimbook'">
                            <div class="row align-items-center">
                                <div class="col-9 font-italic" v-html="$t('UploadProductFiles.ifYouReNotSureAboutYourFiles')"/>
                                <div class="col-3">
                                    <a class="btn btn-outline-primary btn-lg btn-block" href="/pdf/imprimbook/guide_PAO_Imprimbook.pdf"
                                       download="Guide PAO.pdf">
                                        <i class="fa fa-file-pdf fa-2x mr-2"/>
                                        <span v-html="$t('UploadProductFiles.productCreationGuide')"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="text-center my-2">
                            <router-link to="/help/self-publishing" target="_blank" v-html="$t('UploadProductFiles.needSomeHelp')"/>
                        </div>
                        <hr class="mt-4 mb-4"/>
                        <div class="row justify-content-center">
                            <SubmitBtn classes="btn btn-primary" :loading="false" :disabled="!cover.file && !corpus.file"
                                       :text="$t('UploadProductFiles.uploadFiles')"/>
                        </div>
                    </form>
                </div>
                <div v-else-if="status === 'uploading'" id="upload-progress-bar" key="upload-progress-bar" class="col-12">
                    <h3 class="text-center">
                        <img width="100" alt="Uploading..." :src="GIFs.uploadToCloud"/>
                        <span v-html="$t('UploadProductFiles.uploadingFiles')"/>
                    </h3>
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                             :aria-valuenow="progress.percent" aria-valuemin="0" aria-valuemax="100"
                             :style="`width: ${progress.percent}%`"/>
                    </div>
                    <h4 class="text-center text-muted mt-3 text-monospace" v-html="progressText"/>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SubmitBtn from "../../../Misc/SubmitBtn";
import uploadToCloud from "@/assets/gif/upload-to-cloud.gif";
import bookDimensions from "@/assets/img/product-files/book-dimensions.png";
import Product from "@/classes/Product";
import { importSVG } from "@/helpers/file";
import ProductFileStatusBadge from "@/components/shared/Product/ProductFiles/ProductFileStatusBadge";

export default {
    name: "UploadProductFiles",
    components: {ProductFileStatusBadge, SubmitBtn},
    props: {
        product: {
            type: Product,
            required: true,
        },
    },
    data() {
        return {
            cover: {
                file: null,
            },
            corpus: {
                file: null,
            },
            status: "pending",
            progress: { percent: 0 },
            GIFs: {
                uploadToCloud,
            },
            IMGs: {
                bookDimensions,
            },
        };
    },
    computed: {
        ...mapGetters("config", {
            APIClient: "client",
        }),
        coverFileInputLabel() {
            return this.cover.file ? `<i class='fa fa-check text-success mr-2'></i>${this.cover.file.name}` : this.$t("UploadProductFiles.chooseFile");
        },
        corpusFileInputLabel() {
            return this.corpus.file ? `<i class='fa fa-check text-success mr-2'></i>${this.corpus.file.name}` : this.$t("UploadProductFiles.chooseFile");
        },
        progressText() {
            return this.progress.percent !== 100 ? `${this.progress.percent}%` : this.$t("UploadProductFiles.finalizing");
        },
        mailboxSVG() {
            return importSVG("mailbox", this.APIClient);
        },
        addToCartSVG() {
            return importSVG("add_to_cart", this.APIClient);
        },
        coverFileInputTooltip() {
            if (this.product.canUploadCoverFile) {
                return this.$t("UploadProductFiles.fileMustBePDFAndNotTooLarge");
            } else {
                return this.$t("UploadProductFiles.fileCantBeUploadedAnymore");
            }
        },
        corpusFileInputTooltip() {
            if (this.product.canUploadCorpusFile) {
                return this.$t("UploadProductFiles.fileMustBePDFAndNotTooLarge");
            } else {
                return this.$t("UploadProductFiles.fileCantBeUploadedAnymore");
            }
        },
    },
    methods: {
        reset() {
            this.cover.file = null;
            this.corpus.file = null;
            this.status = "pending";
            this.progress.percent = 0;
        },
        checkFileInput(bookPart) {
            const refInput = bookPart === "cover" ? "CoverFileInput" : "CorpusFileInput";
            const files = this.$refs[refInput].files;
            if (!files.length) {
                return this[bookPart].file = null;
            } else {
                const file = files[0];
                try {
                    if (file.type !== "application/pdf") {
                        throw this.$t("UploadProductFiles.chosenFileNotPDF");
                    } else if (file.size > 209715200) {
                        throw this.$t("UploadProductFiles.chosenFileTooBig");
                    }
                    this[bookPart].file = file;
                } catch (e) {
                    this.$toasted.error(e, {icon: "times"});
                    this[bookPart].file = null;
                }
            }
        },
        async sendProductFiles() {
            try {
                this.status = "uploading";
                this.$emit("uploading-files");
                const { data } = await this.$hermesAPI.sendSelfPublishedProductFiles(this.product._id, {
                    corpus: this.corpus,
                    cover: this.cover,
                }, this.progress);
                this.status = "done";
                this.$emit("files-uploaded", data);
                this.$toasted.success(this.$t("UploadProductFiles.filesUploaded"), { icon: "check" });
            } catch (e) {
                this.$error.displayError(e);
                this.$emit("upload-error");
                this.status = "errored";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    #form-content {
        min-height: 175px;
    }

    .badge {
        white-space: normal;
        padding: 10px;
    }

    .custom-file-label-success {
        border-color: #6fb07d;
    }
</style>